import React from "react";
import { RefreshCw, FileDown, LayoutDashboard } from "lucide-react";

const formatUpdated = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("he-IL", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" });
};

const DashboardHeader = ({refreshing, onRefresh, onExport }) => {
  return (
    <div className="relative overflow-hidden rounded-3xl mt-4 sm:mt-6">
      {/* soft gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-25 to-blue-50" />

      {/* content card */}
      <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-3xl p-5 sm:p-6 shadow-2xl shadow-indigo-100/50">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            {/* icon block */}
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md flex-shrink-0">
              <LayoutDashboard className="w-6 h-6" />
            </div>

            {/* text */}
            <div className="min-w-0">
              <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                לוח הבקרה של המנהל
              </h1>
              <p className="text-gray-600 mt-1 truncate">סקירה כללית של פעילות האתר והביצועים העסקיים</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2.5 flex-shrink-0">
            <div className="flex items-center gap-2">
              <button
                onClick={onRefresh}
                disabled={refreshing}
                title="רענון נתונים"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/70 border border-white/60 text-indigo-700 hover:bg-white transition disabled:opacity-50"
              >
                <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`} />
              </button>

              <div className="relative group">
                <button className="flex items-center gap-1.5 h-9 px-3 rounded-xl bg-white/70 border border-white/60 text-indigo-700 text-xs font-bold hover:bg-white transition">
                  <FileDown className="w-4 h-4" /> ייצוא דוח
                </button>
                <div className="absolute left-0 mt-1 w-32 bg-white rounded-xl shadow-xl ring-1 ring-black/5 overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition z-20">
                  <button onClick={() => onExport?.("xlsx")} className="w-full text-right px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50">
                    Excel (.xlsx)
                  </button>
                  <button onClick={() => onExport?.("pdf")} className="w-full text-right px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50">
                    PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;